module.exports = __webpack_public_path__ + "front/img/qrcode01.8c0afb90.jpg";